import { connect } from 'react-redux'
import * as ProfileActions from '../stores/profile/actions';
import * as TackLikesActions from '../stores/tack_likes/actions';
import ProfileComponent from '../components/profile';

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.default.profile,
    user: state.default.user,
    subscription: state.default.subscription,
    params: ownProps.match.params
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadProfile: (slug) => {
      dispatch(ProfileActions.load(slug));
    },
    onFollow: (slug) => {
      dispatch(ProfileActions.follow(slug));
    },
    onUnFollow: (slug) => {
      dispatch(ProfileActions.unfollow(slug));
    },
    onReset: () => {
      dispatch(ProfileActions.reset());
    },
    onLikeTack: (tackSlug) => {
      dispatch(TackLikesActions.like(tackSlug));
    },
    onUnLikeTack: (tackSlug) => {
      dispatch(TackLikesActions.unLike(tackSlug));
    },    
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileComponent);



// WEBPACK FOOTER //
// ./src/containers/profile.js